
function CarouselTags(adminResource) {
  this.waitCarouselTags = true;
  this.data = [];
  this.api = adminResource;
  this.results = null;
  this.error = null;

  this.api.searchTags({
    viewAsCarousel: true
  }).then(function(data) {
    if( data.data ) {
      data.data.forEach( this.push.bind(this) );
    }
    this.waitCarouselTags = false;
  }.bind(this), function(e) {
    console.error(e);
    this.waitCarouselTags = false;
  }.bind(this));
}

CarouselTags.prototype.parse = function(tag) {
  return {
    sefriendly: tag.sefriendly,
    name: tag.name
  };
};

CarouselTags.prototype.save = function() {
  this.waitCarouselTags = true;
  this.error = null;

  this.api.saveCarouselTags(this.data.map( function(t) {
    return t.sefriendly
  })).then(function(data, err) {
    if( err ) {
      this.error = err;
    } else if( ! data ) {
      this.error = 'error save data';
    } else {
      this.results = data;
    }
    this.waitCarouselTags = false;
  }.bind(this), function(e) {
    console.error(e);
    this.error = e;
    this.waitCarouselTags = false;
  }.bind(this));

};

CarouselTags.prototype.push = function(tag) {
  this.data.push( this.parse(tag) );
};

CarouselTags.prototype.array = function() {
  return this.data;
};

CarouselTags.prototype.set = function(tag) {
  const index = this.data.findIndex( function(t) {
    return t.sefriendly === tag.sefriendly
  });

  if( index >= 0 ) {
    this.data.splice(index, 1);
  } else {
    this.push(tag);
  }
};

CarouselTags.prototype.isInArray = function(tag) {
  if( tag.sefriendly ) {
    return this.data.some( function(t) {
      return t.sefriendly === tag.sefriendly
    });
  }
  return false;
};

module.exports = CarouselTags;


// WEBPACK FOOTER //
// ./client/src/app/account/tags/carousel-tags.js